import { Routes } from '@angular/router';
import { FileManagerComponent } from './file-manager.component';

export const FILE_MANAGER_ROUTES: Routes = [{
    path: 'file-manager',
    component: FileManagerComponent,
    data: {
        pageTitle: 'fileManager.title'
    }
}];
